// eslint-disable-next-line no-use-before-define
import React, { FC } from 'react';

type SwitchProps = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void; // eslint-disable-line no-unused-vars
  leftLabel?: string;
  rightLabel?: string;
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
};

const Switch: FC<SwitchProps> = ({
  id,
  checked,
  onChange,
  leftLabel,
  rightLabel,
  disabled = false,
  size = 'sm',
  className = '',
  labelClassName = '',
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  const rightLabelWeightClass =
    Boolean(rightLabel) && checked ? 'fw-bold' : '';

  // pl-0 only when a left label sits beside the control; otherwise keep default
  // padding-left so the absolutely positioned input does not overlap adjacent cells.
  const switchPadClass = leftLabel ? 'pl-0' : '';

  return (
    <div className="d-flex align-items-center">
      {leftLabel && (
        <span
          className={`fs-12px pt-0 mr-5 ${
            checked ? '' : 'fw-bold'
          } ${labelClassName}`}
        >
          {leftLabel}
        </span>
      )}
      <div
        className={`custom-control custom-switch custom-control-${size} ${switchPadClass} ${className}`}
      >
        <input
          type="checkbox"
          className="custom-control-input"
          id={id}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />

        {/* Bootstrap custom-switch needs a label (even visually empty) to render the track */}
        <label
          className={`custom-control-label ${rightLabelWeightClass} ${labelClassName}`}
          htmlFor={id}
        >
          {rightLabel || <span className="sr-only">Toggle</span>}
        </label>
      </div>
    </div>
  );
};

export default Switch;
